import React, { Component } from 'react'
import { FiCheckCircle } from "react-icons/fi";
import { VscError } from "react-icons/vsc";

class TablePayments extends Component {

    constructor(props){
        super(props)
        
        this.state = {
        }
    }

    componentDidMount(){
    }

    render(){
        return(
            <tbody>
                {this.props.paymentList.map((item) => {
                    return(
                        <tr>
                            <td>{item.date}</td>
                            <td>{item.name}</td>
                            <td>R$ {item.price}</td>
                            <td className="text-end">{item.status == 1 ? (<FiCheckCircle stroke="green" />) : (<VscError fill="red" />)}</td>
                        </tr>
                    )
                })}
            </tbody>
        )
    }
}

export default TablePayments; 